import React from 'react';
import PropTypes from 'prop-types';
import AdSense from './AdSense';

/**
 * AdSkyscraper Component
 * 
 * A vertical skyscraper ad (typically 160x600 pixels)
 * Commonly used in sidebars
 * 
 * @param {Object} props Component props
 * @param {string} props.adSlot The ad unit ID
 * @param {Object} props.style Additional inline styles
 * @param {string} props.className Additional CSS classes
 */
const AdSkyscraper = ({ adSlot, style, className }) => {
  const skyscraperStyle = {
    width: '160px',
    height: '600px',
    maxHeight: '100vh',
    ...style
  };
  
  return (
    <AdSense
      adSlot={adSlot}
      adFormat="vertical"
      style={skyscraperStyle}
      className={`ad-skyscraper ${className || ''}`}
    />
  );
};

AdSkyscraper.propTypes = {
  adSlot: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

AdSkyscraper.defaultProps = {
  adSlot: 'skyscraper-ad-slot',
  style: {},
  className: ''
};

export default AdSkyscraper; 